import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function Legal() {
  const { doc } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get(`/legal/${doc}`).then(({ data }) => setData(data)).catch(() => setData(false)); }, [doc]);

  if (data === false) return <div className="max-w-3xl mx-auto px-6 py-20 text-center text-muted-foreground">Document not found.</div>;
  if (!data) return <div className="min-h-[50vh]" />;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-head text-4xl font-black tracking-tighter mb-2">{data.title}</h1>
      <p className="text-xs text-muted-foreground mb-8">Version {data.version} · Effective {data.effective_date}</p>
      <div className="space-y-4 text-muted-foreground leading-relaxed">
        {data.body.split("\n\n").filter(Boolean).map((para, i) => {
          const lines = para.split("\n");
          const isHeading = lines[0].length < 60 && !lines[0].endsWith(".") && lines.length <= 2;
          return isHeading
            ? <div key={i}><h2 className="font-head text-lg font-bold text-white mb-1">{lines[0]}</h2>{lines[1] && <p>{lines[1]}</p>}</div>
            : <p key={i}>{para}</p>;
        })}
      </div>
    </div>
  );
}
